var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8925 7.64434C12.8925 6.2609 11.771 5.1394 10.3876 5.1394H8.27403C7.49038 5.1394 6.85498 5.77481 6.85498 6.55846V17.4346C6.85498 18.2183 7.49038 18.8537 8.27403 18.8537H16.0786C16.8624 18.8537 17.4979 18.2183 17.4979 17.4346V12.2496C17.4979 10.8661 16.3764 9.74457 14.9929 9.74457C13.8348 9.74457 12.8925 8.80246 12.8925 7.64434ZM15.2705 16.3224H8.69246C8.3975 16.3224 8.1584 16.0832 8.1584 15.7885C8.1584 15.4933 8.3975 15.2542 8.69246 15.2542H15.2705C15.5653 15.2542 15.8042 15.4933 15.8042 15.7885C15.8044 16.0832 15.5654 16.3224 15.2705 16.3224ZM15.2705 14.0968H8.69246C8.3975 14.0968 8.1584 13.8577 8.1584 13.5629C8.1584 13.2678 8.3975 13.0287 8.69246 13.0287H15.2705C15.5653 13.0287 15.8042 13.2678 15.8042 13.5629C15.8044 13.8577 15.5654 14.0968 15.2705 14.0968ZM15.8044 11.2849C15.8044 11.5799 15.5654 11.819 15.2706 11.819H8.6926C8.39764 11.819 8.15854 11.5799 8.15854 11.2849C8.15854 10.9899 8.39764 10.7508 8.6926 10.7508H15.2706C15.5654 10.7508 15.8044 10.9899 15.8044 11.2849Z",
    fill: "#448055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9964 9.06412C15.9208 9.06412 16.3837 7.94645 15.7301 7.2928L15.3486 6.91136C14.695 6.25773 13.5773 6.72067 13.5773 7.64507C13.5773 8.42872 14.2127 9.06412 14.9964 9.06412Z",
    fill: "#448055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPreview);
export default __webpack_public_path__ + "static/media/docPreview.c59ce777.svg";
export { ForwardRef as ReactComponent };